/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@mui/material";
import ModelSelector from "components/model-selector";
import { SVGIcons } from "cms/icons/svg-icons";
import { modelItems } from "data/resources/model-items-config";
import useStyles from "cms/fields/_styles";

function ModelSelectorWrapper (props) {

    const { t } = useTranslation();
    const classes = useStyles();
    const onModelChange = props.onModelChange; // updates the component
    const onModelRemove = props.onModelRemove; // updates the component
    const filter = props.filter;
    const filterValue = props.filterValue;
    const [model, setModel] = useState(props.model);

    useEffect(() => {
        setModel(props.model);
    }, [props.model]);
    //------------------------------------------------
    const onSelectModel = async (model) => {
        setModel(model);
        onModelChange(model);
    };
    const onModelRemoved = async (model) => {
        onModelRemove(model);
    };
    const AddComponent = ({ setOpen }) => {
        return (
            <div className='simplicity-composer-helpful'>
                <Box className={classes.boxContainer}>
                    <Button
                        color='primary'
                        variant='contained'
                        onClick={() => {
                            setOpen(true);
                        }}
                    >
                        <SVGIcons.common.Create sx={{ marginRight: "8px" }} /> {t("commons.addModel")}
                    </Button>
                </Box>
            </div>
        );
    };

    const DisplayComponent = ({ onChange, onRemove, model }) => {
        return (
            <div
                style={{
                    border: "1px solid #c4c4c4",
                    borderRadius: "8px",
                    backgroundColor: "#f4f4f4",
                    width: "100%",
                    height: "70px",
                    padding: "12px",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "12px",
                    }}
                >
                    <div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                margin: 12,
                                width: "24px",
                                height: "24px",
                                fill: "#989898",
                            }}
                        >
                            {modelItems[model.type]?.img}
                        </div>
                    </div>
                    <div style={{ flexGrow: 1 }}>
                        <div
                            style={{
                                color: "#676767",
                                fontSize: "14px",
                                fontWeight: "600",
                            }}
                        >
                            {modelItems[model.type]?.name}
                        </div>
                        <div>{model.title}</div>
                    </div>
                    <Button variant='outlined'>Hide</Button>
                    <Button variant='outlined' onClick={() => onRemove(model)}>
                        Remove
                    </Button>
                    <Button variant='contained' onClick={() => onChange(model)}>
                        Change
                    </Button>
                </div>
            </div>
        );
    };

    return (
        <ModelSelector
            AddComponent={AddComponent}
            DisplayComponent={DisplayComponent}
            model={model}
            setModel={setModel}
            onSelectModel={onSelectModel.bind(this)}
            onModelRemoved={onModelRemoved.bind(this)}
            filter={filter}
            filterValue={filterValue}
        />
    );
}

export default ModelSelectorWrapper;
